import React from 'react'
import { Row, Col } from 'antd';
import HistoryInfo from './HistoryInfo'

const PaymentHistoryView = () => {
    document.body.style.setProperty("background", "#fff", "important")
    return (
        <>
            <Row>
                <Col span={24}>
                    <section className="sec1">
                        <HistoryInfo />
                    </section>
                </Col>
            </Row>
        </>
    )
}

export default PaymentHistoryView